import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { RouteLoading } from '@ocx/ui';
import { ConfigGuard } from '@ocx/data-configuration';

import { AppRoutePath } from '../../AppRoutePath';

const OfferDetailsController = lazy(() =>
  import('../../OfferDetails/offer-details.controller').then((m) => ({ default: m.OfferDetailsController })),
);
const SurveyDetailsController = lazy(() =>
  import('../../SurveyDetails/survey-details.controller').then((m) => ({ default: m.SurveyDetailsController })),
);
const SpireEnrollmentController = lazy(() =>
  // eslint-disable-next-line @nx/enforce-module-boundaries -- lazy nested route; matches AppRoutes pattern
  import('@ocx/feat-spire').then((m) => ({ default: m.SpireEnrollmentController })),
);

export const HomeRoutes = () => {
  return (
    <Suspense fallback={<RouteLoading />}>
      <Routes>
        <Route path={AppRoutePath.OfferDetails} element={<OfferDetailsController returnPath={AppRoutePath.Home} />} />
        <Route
          path={AppRoutePath.OfferDetailsAutoIdentify}
          element={<OfferDetailsController autoIdentify returnPath={AppRoutePath.Home} />}
        />
        <Route
          path={AppRoutePath.SurveyDetails}
          element={
            <ConfigGuard _isRedirectRequired={(c) => !c.surveys.enabled}>
              <SurveyDetailsController returnPath={AppRoutePath.Home} />
            </ConfigGuard>
          }
        />
        <Route
          path={AppRoutePath.SpireEnrollmentHome}
          element={
            <SpireEnrollmentController returnPath={AppRoutePath.Home} spireWebviewPath={AppRoutePath.SpireEnrollment} />
          }
        />
      </Routes>
    </Suspense>
  );
};
